export const FEATURE_FLAGS_LOCAL_STORAGE_KEY = '@winnin/insights:flags';